module.exports = __webpack_public_path__ + "img/4.a7d5d537.jpg";